var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"share-img"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"分享图"}})]),_c('div',{ref:"box",staticClass:"creat-img"},[_c('img',{attrs:{"src":require("@/assets/recruit/bg.png"),"alt":"分享背景图"}}),_c('div',{staticClass:"qrcode",attrs:{"id":"qrcode"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }